export const GET_USER = "auth/GET_USER";
export const LOGIN = "auth/LOGIN";
export const LOGOUT = "auth/LOGOUT";
export const REGISTER = "auth/REGISTER";
